import React from 'react';
import { motion } from 'framer-motion';
export function FinalCtaSection() {
  return <section className="py-24 bg-pastel-mintLight/50 relative overflow-hidden" data-id="element-34">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-pastel-yellow rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob" data-id="element-35" />
      <div className="absolute top-0 right-0 w-64 h-64 bg-pastel-lilac rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000" data-id="element-36" />
      <div className="absolute -bottom-32 left-1/2 w-64 h-64 bg-pastel-blue rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-4000" data-id="element-37" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-38">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white/80 backdrop-blur-md rounded-[3rem] p-8 md:p-16 shadow-xl border border-white" data-id="element-39">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-800 mb-6" data-id="element-40">
            Comenzá hoy mismo
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-41">
            Ayudá a tu hijo a desarrollar habilidades fundamentales mientras
            aprende jugando.
          </p>

          <div className="flex flex-col items-center" data-id="element-42">
            <motion.a href="https://checkout.complementodigital.shop/cart/40783303901313:1" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} animate={{
            y: [0, -5, 0]
          }} transition={{
            y: {
              duration: 2,
              repeat: Infinity,
              ease: 'easeInOut'
            }
          }} className="w-full sm:w-auto px-10 py-5 bg-pastel-yellow hover:bg-[#FDE073] text-slate-800 font-bold text-2xl rounded-2xl shadow-xl transition-colors mb-4 inline-flex items-center justify-center text-center" data-id="element-43">
              🔥 SOLO POR HOY $24.990
            </motion.a>
            <p className="text-slate-400 line-through font-medium mb-6" data-id="element-44">
              Precio habitual $49.990
            </p>
            <p className="text-slate-500 font-medium bg-slate-50 px-6 py-3 rounded-full border border-slate-100" data-id="element-45">
              Incluye 5 módulos, 6 bonus, 3 plus y plantillas imprimibles.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}